import camelcaseKeys from 'camelcase-keys'
import { WebappPage } from './WebappPage'
import { PagePreconfigured } from './page-types/Preconfigured'
import { pageTypes } from '@/config'

export class DashboardPage {
  constructor (params = {}) {
    const { pageName, pageId, page, order, enabled, preconfiguredPage } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.pageName = pageName || null
    this.pageId = pageId || null
    this.order = order
    this.enabled = enabled
    this.page = page ? new WebappPage(page) : null
    this.preconfiguredPage = preconfiguredPage ? new PagePreconfigured(preconfiguredPage) : null
    this.type = preconfiguredPage ? pageTypes.PRECONFIGURED : page.type
  }
}
